import { HttpErrorResponse } from '@angular/common/http';
import { Component, input, output, signal, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { WorkflowEtapeInstance } from 'src/app/bo/workflowEtapeInstance';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-security-window',
  templateUrl: './security-window.component.html',
  styleUrls: ['./security-window.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecurityWindowComponent implements OnInit {
  readonly hauteurExplorer = input<number>(0);
  readonly securityIsChange = output<WorkflowEtapeInstance>();

  protected stepId = signal<number>(0);
  protected workflowEtapeInstance = signal<WorkflowEtapeInstance>(new WorkflowEtapeInstance());

  constructor(
    private readonly http: HttpService,
    public router: Router,
    private readonly fonctionsService: FonctionsService
    ) { }

  ngOnInit(): void {
   this.setStepIdFromUrl();
   this.setworkflowEtapeInstance();
  }

  private setStepIdFromUrl(){
    let lastUrlParam = this.router.url.split('&').pop();
    this.stepId.set(Number(lastUrlParam.split('=').pop()));
  }

  private setworkflowEtapeInstance(){
    //check this.stepId is not nan
    if(!isNaN(this.stepId()) && this.stepId() != null){
      this.http.get('WorkflowSteps/' + this.stepId()  +'/WorkflowStepInstanceById').subscribe((res:WorkflowEtapeInstance) => {
      console.log(res)
        this.workflowEtapeInstance.set(res);
      },(error: HttpErrorResponse)=>{
        if(error.status === 401 || error.status === 403){
        console.log(error.error);
        }
    })
    }
    console.error('stepId is not a number: ', this.stepId());
  }

  protected onChange() {
    this.fonctionsService.loading_screen(true);
    const value = this.workflowEtapeInstance().accessPermission;
    this.http.put('WorkflowSteps/' + this.stepId()  + '/UpdateWorkflowStepInstance', value).subscribe((result: number) =>{
        this.fonctionsService.loading_screen(false);
        this.fonctionsService.launch_toast(true);
        this.securityIsChange.emit(this.workflowEtapeInstance());
    },(error: HttpErrorResponse)=>{
      if(error.status === 401 || error.status === 403){
    console.log(error.error);
      }
      this.fonctionsService.loading_screen(false);
      this.fonctionsService.launch_toast(false);
    })
  }



}
